import { sitecoreApiKey } from '@shared/configs/configs/config';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_HOME_PAGE_TRENDING_ARTICLES_URL } from '@shared/utils/api/configs/URL';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetHomePageTrendingArticlesResult } from '../types/getHomePageTrendingArticles.types';

export const HOME_PAGE_TRENDING_ARTICLES_TAGS = 'getHomePageTrendingArticles';

export const getHomePageTrendingArticles = (builder: BuilderType) =>
  builder.query<GetHomePageTrendingArticlesResult, void>({
    providesTags: [HOME_PAGE_TRENDING_ARTICLES_TAGS],
    query: () => ({
      method: 'GET',
      overrideOptions: {
        headers: {
          sc_apikey: sitecoreApiKey(),
        },
        params: {
          sc_apikey: sitecoreApiKey(),
        },
        withCredentials: false,
      },
      url: GET_HOME_PAGE_TRENDING_ARTICLES_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetHomePageTrendingArticlesResult>) => {
      if (response?.[0]?.data) {
        return response?.[0]?.data;
      }

      throw {
        code: response?.InternalErrorCode,
        message: response?.Message,
      };
    },
  });
